export const SCREEN_SHARE_STARTING_PRIORITY = 1000; // Priority for screen sharing streams
export const VIDEO_STARTING_PRIORITY = 2000; // Priority for other video streams
export const LAST_VIDEO_BOX_PRIORITY = 20000; // Priority for the last video boxes
